import { isDefined } from '@sgme/fp';
import { connect } from 'react-redux';
import type { SecondaryMarketProduct } from 'state/secondaryMarket/productSearch';
import {
  isCpOrderEnabled,
  isLiveQuoteEnabled,
  isRealtimeQuoteEnabled,
} from 'state/secondaryMarket/productSearch/productSearch.selectors';
import { getRowIdFromSecondaryMarketProduct } from 'state/secondaryMarket/productSearch/productSearch.utils';
import { isSecondaryMarketAstroProductLoading } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { isSecondaryMarketCpOrderEnabledForUser, isSecondaryMarketLiveQuoteEnabledForUser } from 'state/user';
import { secondaryQuoteRefreshRowThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';

type OwnProps = {
  isOpen: boolean;

  data: SecondaryMarketProduct | null | undefined;
  onClose: () => void;

  onToggleOpen: () => void;
};

type StateProps = {
  hasRefreshButton: boolean;
  isRefreshing: boolean;
};

type DispatchProps = {
  onRefresh: () => void;
};

export type ModalContentProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { data }: OwnProps): StateProps => {
  if (!isDefined(data)) {
    return {
      hasRefreshButton: false,
      isRefreshing: false,
    };
  }
  const rowId = getRowIdFromSecondaryMarketProduct(data);
  const isin = data.isin;
  const isRealtimeQuoteMissing = !isRealtimeQuoteEnabled(state, rowId);
  const isCpOrderMissing = isSecondaryMarketCpOrderEnabledForUser(state) && !isCpOrderEnabled(state, rowId);
  const isLiveQuoteMissing = isSecondaryMarketLiveQuoteEnabledForUser(state) && !isLiveQuoteEnabled(state, rowId);
  const isAstroProductLoading = isin !== undefined && (isSecondaryMarketAstroProductLoading(state, isin) ?? true);

  return {
    hasRefreshButton: isRealtimeQuoteMissing || isCpOrderMissing || isLiveQuoteMissing,
    isRefreshing: isAstroProductLoading,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch, { data }: OwnProps): DispatchProps => ({
  onRefresh: () => {
    if (isDefined(data)) {
      const rowId = getRowIdFromSecondaryMarketProduct(data);
      dispatch(secondaryQuoteRefreshRowThunk(rowId));
    }
  },
});

export const connectProductSummaryModal = connect(mapStateToProps, mapDispatchToProps);
